import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiFileText, FiZap } from "react-icons/fi";
import Posts from "../component/Posts";
import { UserContext } from "../context/userContext";
import { CATEGORIES } from "../constants";

const TICKER = [...CATEGORIES, "Distributed systems", "Databases", "System design", "DevOps"];

const Home = () => {
  const { currentUser } = useContext(UserContext);
  const [count, setCount] = useState(null);
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () =>
      setTime(new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }));
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="hero__badge reveal">
            <b>New</b> Gemini-powered notes &amp; drills
          </div>

          <h1 className="hero__title">
            <span className="mask">
              <span>Engineering notes,</span>
            </span>
            <span className="mask">
              <span className="ink-italic" style={{ animationDelay: "0.1s" }}>
                written in the open.
              </span>
            </span>
          </h1>

          <p className="hero__lead reveal" style={{ animationDelay: "0.25s" }}>
            BrainBytes is a knowledge base for developers. Write up what you learn, read how
            others build, and let AI turn any topic into notes or a quick Q&amp;A drill.
          </p>

          <div className="hero__actions reveal" style={{ animationDelay: "0.35s" }}>
            <Link to={currentUser?.id ? "/create" : "/register"} className="btn btn--primary btn--lg">
              Start writing <FiArrowUpRight />
            </Link>
            <a href="#latest" className="btn btn--lg">
              Read the feed
            </a>
          </div>

          <div className="hero__foot statusbar reveal" style={{ animationDelay: "0.45s" }}>
            <span>
              <span className="live-dot" />
              Feed live · <b className="num">{count === null ? "—" : String(count).padStart(2, "0")}</b>{" "}
              posts
            </span>
            <span>
              Topics · <b className="num">{String(CATEGORIES.length).padStart(2, "0")}</b>
            </span>
            <span className="num">Local {time}</span>
          </div>
        </div>
      </section>

      <div className="marquee" aria-hidden>
        <div className="marquee__track">
          {[...TICKER, ...TICKER].map((t, i) => (
            <span className="marquee__item" key={i}>
              {t}
            </span>
          ))}
        </div>
      </div>

      <section className="container" style={{ paddingTop: 96 }}>
        <div className="section-head">
          <div>
            <div className="sec">
              <span className="sec__num">01</span>
              <span className="eyebrow">— Tools</span>
            </div>
            <h2>
              Learn faster, <span className="ink-italic">with a co-pilot.</span>
            </h2>
          </div>
        </div>

        <div className="tools">
          <Link to="/ai" className="tool-card tool-card--accent">
            <span className="tool-card__icon">
              <FiFileText />
            </span>
            <span className="tool-card__arrow">
              <FiArrowUpRight />
            </span>
            <span className="eyebrow">Generate</span>
            <h3>AI Note Generator</h3>
            <p>Type a topic, get structured technical notes you can copy straight into your docs.</p>
          </Link>
          <Link to="/fact" className="tool-card">
            <span className="tool-card__icon">
              <FiZap />
            </span>
            <span className="tool-card__arrow">
              <FiArrowUpRight />
            </span>
            <span className="eyebrow">Practice</span>
            <h3>QuickLearn</h3>
            <p>Turn any concept into a set of interview-style questions and answers.</p>
          </Link>
        </div>
      </section>

      <section id="latest" className="container" style={{ scrollMarginTop: 80 }}>
        <div className="section-head">
          <div>
            <div className="sec">
              <span className="sec__num">02</span>
              <span className="eyebrow">— Latest</span>
            </div>
            <h2>
              Fresh from <span className="ink-italic">the community.</span>
            </h2>
          </div>
          <div className="chips">
            {CATEGORIES.map((c) => (
              <Link key={c} to={`/posts/categories/${c}`} className="chip chip--filter">
                {c}
              </Link>
            ))}
          </div>
        </div>

        <Posts onCount={setCount} />
      </section>
    </>
  );
};

export default Home;
